import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { Field, reduxForm, propTypes as formProps } from 'redux-form';

import { RenderField, RenderSubmitButton } from '../../components/common/form';
import FacebookLoginButton from '../../components/common/auth/FacebookLoginButton';
import * as Validations from '../../components/common/form/commonValidations';
import MinimalFooter from '../../components/common/footer/MinimalFooter';

import { login } from '../../actions/AuthActions';

import '../../stylesheets/pages/preauth/SignupPageContainer.less';

class LoginFullPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      errorMessage: ''
    };

    this.handleLogin = this.handleLogin.bind(this);
    this.handleError = this.handleError.bind(this);
    this.handleLoginSuccess = this.handleLoginSuccess.bind(this);
  }

  handleLogin(values) {
    this.setState({ error: false });
    const { onLogin } = this.props;
    onLogin(values)
      .then(() => this.handleLoginSuccess())
      .catch(this.handleError);
  }

  handleError(error) {
    this.setState({ error: true, errorMessage: error.detailedMessage });
  }

  handleLoginSuccess() {
    window.location.href = '/';
  }

  render() {
    const { pristine, submitting, valid, handleSubmit } = this.props;
    const { error, errorMessage } = this.state;

    return (
      <div className="full-page-signup">
        <Helmet
          style={[
            {
              type: 'text/css',
              cssText: ` html, .main-content {
                background: #FCFCFC;
              }
              body {
                margin-bottom: 75px;
              }`
            }
          ]}
        />
        <header className="minimal-header">
          <a href="/" target="_self">
            <div className="zola-logo-horizontal-black center-block" />
          </a>
        </header>
        <div className="text-h1 intent-title col-xs-12 text-center">
          Log In
        </div>
        <div className="signup-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                <form onSubmit={handleSubmit(this.handleLogin)} >
                  <Field
                    className="center-block"
                    name="email"
                    type="email"
                    placeholder="Email"
                    id="login-email"
                    component={RenderField}
                    required
                    validate={[Validations.REQUIRED, Validations.EMAIL]}
                  />
                  <div className="form-group center-block">
                    <Field
                      name="password"
                      id="login-password"
                      type="password"
                      component={RenderField}
                      placeholder="Password (8 or more characters)"
                      hideFormGroup
                      required
                      validate={Validations.REQUIRED}
                    />
                    <span className="help-block forgot-password text-right small"><Link to="/onboard/forgot">Forgot Password?</Link></span>
                  </div>
                  <RenderSubmitButton disabled={pristine || submitting || !valid} submitting={submitting} valid value="Log In" className="btn-primary btn btn-lg center-block" />
                  <FacebookLoginButton buttonText="Log In With Facebook" callback={this.handleLoginSuccess} errorCallback={this.handleError} />
                  <div className="clearfix" />
                  {error &&
                  <div className="form-message-block text-center text-danger">
                    {errorMessage || 'There was a problem processing your request. Please try again or contact customer support for assistance.'}<br /><br /></div>
                  }
                </form>
                <div className="signup-footer">
                  <p className="text-center margin-top-10">Don&apos;t have an account?</p>
                  <p className="text-center">
                    <Link to="/onboard/select-product">Sign up now ›</Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MinimalFooter />
      </div>
    );
  }
}

LoginFullPage.propTypes = {
  // onSuccess: PropTypes.func.isRequired,
  location: PropTypes.shape({}),
  handleSubmit: PropTypes.func.isRequired,
  ...formProps,
};

const mapDispatchToProps = dispatch => ({
  onLogin: loginFormRequest => dispatch(login(loginFormRequest))
});

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'LoginForm'
})(LoginFullPage));



// WEBPACK FOOTER //
// ./src/pages/preauth/LoginPageContainer.jsx